import styled from "styled-components";

import { inputTextCSS } from "@/components/ui/input/InputText";

export const InputTextArea = styled.textarea`
    ${inputTextCSS};
`;
